import { useGoogleLogin } from '@react-oauth/google'
import { IconButton } from '@mui/material'
import Iconify from '../iconify'

interface props {
  onGoogleLoginSuccess: (code: string) => void
  googleLoading: boolean
}

const GoogleLoginButton = ({ onGoogleLoginSuccess, googleLoading }: props) => {
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      onGoogleLoginSuccess(codeResponse.code)
    },
    onError: (errorResponse) => {
      console.warn(errorResponse)
    },
  })

  return (
    <IconButton
      onClick={() => googleLogin()}
      sx={{ border: '1px solid #e8ecee', width: 48, height: 48 }}
      disabled={googleLoading}
    >
      <Iconify icon='flat-color-icons:google' sx={{ width: 32, height: 32 }} />
    </IconButton>
  )
}

export default GoogleLoginButton
